<template>
  <sticky-header-layout>
    <!-- Header -->
    <template #header>
      <div class="action-container">
        <span>
          <el-button
            :disabled="isSaving"
            class="cancel-button"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >
            {{ $t('button.cancel') }}
          </el-button>
          
          <el-button
            :disabled="isLoading"
            :loading="isSaving"
            class="save-button"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </span>
      </div>
    </template>
    <!-- Header -->

    <el-form
      ref="cpcCampaignForm"
      :model="cpcCampaignForm"
      label-width="150px"
    >
      <el-form-item
        label="Store"
        prop="selectedStore"
      >
        <gx-select
          v-model="cpcCampaignForm.selectedStore"
          :options="stores"
          :show-label="false"
          track-by="id"
          label="name"
          style="max-width: 160px;"
        >
          <template #selectedLabel="{ option }">{{ option.name }}</template>
          <template #option="{ option }">{{ option.name }}</template>
        </gx-select>
      </el-form-item>

      <el-form-item
        label="Date Range"
        prop="selectedDateRange"
      >
        <el-date-picker
          v-model="cpcCampaignForm.selectedDateRange"
          type="daterange"
          unlink-panels
          range-separator="-"
          start-placeholder="Start date"
          end-placeholder="End date"
          value-format="yyyy-MM-dd"
          :shortcuts="shortcuts"
        />
      </el-form-item>

      <h4 class="title">Brands</h4>

      <div 
        v-if="cpcCampaignForm.selectedStore"
        v-for="brand in cpcCampaignForm.brands"
      >
        <el-form-item
          label="Brand"
          prop="selectedBrand"
        >
          <gx-select
            v-model="brand.selectedBrand"
            :options="brands"
            :show-label="false"
            track-by="id"
            label="name"
            style="max-width: 160px;"
          >
            <template #selectedLabel="{ option }">{{ option.name }}</template>
            <template #option="{ option }">{{ option.name }}</template>
          </gx-select>
        </el-form-item>

        <el-form-item 
          label="Target"
          prop="target"
        >
          <span slot="label">Target</span>
          <el-input 
            style="max-width: 60px;"
            v-model.trim="brand.target"
          />
        </el-form-item>

        <hr/>
      </div>
    </el-form>
  <sticky-header-layout>
</template>

<script>
import CPCCampaignService from '../../api/cpc-campaign'

import addMonths from 'date-fns/addMonths'
import endOfDay from 'date-fns/endOfDay'
import startOfMonth from 'date-fns/startOfMonth'
import lastDayOfMonth from 'date-fns/lastDayOfMonth'

export default {
  name: 'CPCCampaignDetail',
  props: {
    id: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      cpcCampaignForm: {
        selectedStore: null,
        selectedDateRange: null,
        startDate: null,
        endDate: null,
        brands: [],
      },
      stores: [],
      brands: [],
      shortcuts: [],
      isEditMode: false,
      isLoading: false,
      isSaving: false,
    }
  },
  async mounted() {
    const { data } = await CPCCampaignService.listOptions()

    const today = new Date()
    const nextMonthToday = addMonths(today, 1)

    this.shortcuts.push({
      text: 'This Month',
      value: () => {
        return [startOfMonth(today), endOfDay(lastDayOfMonth(today))]
      }
    })

    this.shortcuts.push({
      text: 'Next Month',
      value: () => {
        return [startOfMonth(nextMonthToday), endOfDay(lastDayOfMonth(nextMonthToday))]
      }
    })

    this.stores = data.stores
    this.brands = data.brands

    for (let i = 0; i < 10; i++) {
      this.cpcCampaignForm.brands.push({
        selectedBrand: null,
        target: 0,
      })
    }
  },
  methods: {
    handleCancel() {
      this.goToListPage()
    },
    async handleSave() {
      this.isSaving = true

      let storeId = 0
      let startDate = ''
      let endDate = ''
      let brands = []

      if (this.cpcCampaignForm.selectedStore) {
        storeId = this.cpcCampaignForm.selectedStore.id
      }

      if (this.cpcCampaignForm.selectedDateRange && this.cpcCampaignForm.selectedDateRange.length === 2) {
        startDate = this.cpcCampaignForm.selectedDateRange[0]
        endDate = this.cpcCampaignForm.selectedDateRange[1]
      }

      this.cpcCampaignForm.brands.forEach(brand => {
        if (brand.selectedBrand) {
          brands.push({
            id: brand.selectedBrand.id,
            target: brand.target,
          })
        }
      })

      if (storeId > 0 && startDate !== '' && endDate !== '' && brands.length > 0) {
        const cpcCampaign = {
          store_id: storeId,
          start_date: startDate,
          end_date: endDate,
          brands: brands,
        }

        if (this.isEditMode) {
          
        } else {
          try {
            const result = await CPCCampaignService.create(cpcCampaign)

            this.isSaving = false
            this.goToListPage()
          } catch (error) {
            this.handleSaveFail(error)
          }
        }
      } else {
        this.handleSaveFail('Please fill in all information.')
      }
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
    goToListPage() {
      this.$router.push({ path: '/cpc-campaign/list' })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
@import "~@/assets/styles/form.scss";

</style>